var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInclusivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2380",
    "data-name": "Rettangolo 2380",
    width: 17.781,
    height: 16.917,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5585",
    "data-name": "Raggruppa 5585",
    transform: "translate(-948 -484)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2494",
    "data-name": "Rettangolo 2494",
    width: 24,
    height: 24,
    transform: "translate(948 484)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_550",
    "data-name": "Ellisse 550",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(950 486)",
    fill: "#f5f1ea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5531",
    "data-name": "Raggruppa 5531",
    transform: "translate(951.965 486.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5334",
    "data-name": "Raggruppa 5334",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9764",
    "data-name": "Tracciato 9764",
    d: "M243.372,238.619V236.7c0-.009-.008-.017-.011-.026v-2.51h-2.54a.4.4,0,0,1-.176-.577c.345-.554.424-1.238-.216-1.614a1.118,1.118,0,0,0-1.518.42,1.165,1.165,0,0,0,.179,1.208.4.4,0,0,1-.184.563H236.4v2.484a.4.4,0,0,0,.6.241c.554-.345,1.238-.423,1.614.216a1.114,1.114,0,0,1-.45,1.506c-.435.236-.784.046-1.178-.168a.375.375,0,0,0-.584.243v2.44h1.761v.006h3.784v-.006h1.419v-2.481c0-.009.007-.017.011-.025",
    transform: "translate(-228.635 -224.214)",
    fill: "#fdd661"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9765",
    "data-name": "Tracciato 9765",
    d: "M33.217,306.057c-.376-.64-1.061-.561-1.614-.216a.4.4,0,0,1-.611-.339v-2.315h-2.47a.4.4,0,0,0-.21.574,1.165,1.165,0,0,1,.18,1.208,1.118,1.118,0,0,1-1.518.421c-.64-.376-.561-1.06-.217-1.614a.4.4,0,0,0-.206-.588H24.074v-.019h-.034v-.042h-.01v6.963h6.963v-2.346a.4.4,0,0,1,.6-.347,1.165,1.165,0,0,0,1.208.179,1.118,1.118,0,0,0,.42-1.518",
    transform: "translate(-23.24 -293.172)",
    fill: "#0f38c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9766",
    "data-name": "Tracciato 9766",
    d: "M244.175,8.729l2.241-6.441-.032-.011L239.84,0l-.781,2.245a.4.4,0,0,1-.689.119c-.409-.508-1.03-.807-1.6-.327a1.118,1.118,0,0,0-.1,1.572,1.165,1.165,0,0,0,1.2.227.4.4,0,0,1,.451.524l-.771,2.215,2.3.8a.4.4,0,0,0,.421-.472,1.165,1.165,0,0,1,.227-1.2,1.118,1.118,0,0,1,1.572.1c.481.565.182,1.186-.326,1.6a.4.4,0,0,0,.031.645l1.39.484.924.321.032.011Z",
    transform: "translate(-228.635)",
    fill: "#fc7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9767",
    "data-name": "Tracciato 9767",
    d: "M7.455,67.324a.375.375,0,0,0-.609-.171c-.365.259-.689.49-1.149.308a1.114,1.114,0,0,1-.627-1.441c.3-.68.985-.685,1.576-.409A.4.4,0,0,0,7.21,65.3l-.176-1.461-.117-.971,0-.034-.786.095-5.828.7h0l-.3.036L0,63.7l.108.9L.3,66.161c0,.009,0,.018-.008.027l.23,1.907c0,.008.009.015.013.023l.3,2.463.034,0,0,.019.9-.108L3.33,70.3a.4.4,0,0,1,.275.559c-.276.591-.272,1.28.409,1.576a1.118,1.118,0,0,0,1.457-.6,1.165,1.165,0,0,0-.324-1.177.4.4,0,0,1,.14-.595l2.463-.3-.122-1.012h0Z",
    transform: "translate(0 -60.771)",
    fill: "#a2cbff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInclusivity);
export default __webpack_public_path__ + "static/media/inclusivity.0ec6a672b9f468a5ee8fa9e6c20fcf46.svg";
export { ForwardRef as ReactComponent };